import React from 'react'
import { BasePicker, Calendar, MuiPickersUtilsProvider } from 'material-ui-pickers'
import Paper from '@material-ui/core/Paper'
import PropTypes from 'prop-types'
import moment2 from 'moment'
import MomentUtils from '@date-io/moment'
import 'moment/min/locales.min'

function MyDatePicker(props) {
  // eslint-disable-next-line react/prop-types
  moment2.locale(props.language)
  return (
    <MuiPickersUtilsProvider
      libInstance={moment2}
      locale={
        // eslint-disable-next-line react/prop-types
        props.language
      }
      utils={MomentUtils}
    >
      <BasePicker value={props.value} onChange={props.onChange} initialFocusedDate={null}>
        {({ date, handleChange }) => (
          <div style={{ display: 'inline-block' }}>
            <Paper style={{ overflow: 'hidden' }}>
              <Calendar disablePast date={date} onChange={props.onChange} allowKeyboardControl={false} />
            </Paper>
          </div>
        )}
      </BasePicker>
    </MuiPickersUtilsProvider>
  )
}

MyDatePicker.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired
}

export default MyDatePicker
